(function () {
  'use strict';

  function wipeBackground(ev) {
    var t = ev.target;
    if (!t || !t.closest || t.tagName !== 'IMG') return;
    var holderTarget = t.closest('[data-wipe-background]');
    if (!holderTarget) return;
    holderTarget.style.backgroundImage = 'none';
  }

  function markFadeEligible(img) {
    if (!(img instanceof HTMLImageElement)) return;
    if (
      img.classList.contains('fade-in') ||
      img.classList.contains('background-size-cover')
    ) {
      img.classList.add('lazyloaded');
    }
  }

  function onLoad(ev) {
    wipeBackground(ev);
    var t = ev.target;
    if (t.tagName === 'IMG') markFadeEligible(t);
  }

  document.addEventListener('load', onLoad, true);

  function scanImages() {
    document.querySelectorAll('img.fade-in, img.background-size-cover').forEach(function (img) {
      if (img.complete) {
        // Cached images can be complete before the delegated load listener sees
        // the event. Keep the low-resolution holder background from remaining
        // visible in that case.
        if (img.naturalWidth > 0) wipeBackground({ target: img });
        markFadeEligible(img);
      }
      else img.addEventListener('load', function () { markFadeEligible(img); }, { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanImages, {
      passive: true,
      once: true,
    });
  } else {
    scanImages();
  }
})();
